import { ContactModel } from "../../../models/ContactModel";
import { useIoContext } from "../../../contexts";
import { useContacts } from "../queries/useContacts";
import { useQueryState } from "../useQueryState";
import { QueryKeys } from "../queryKeys";
import { useMemo } from 'react';
const EMPTY_CONTACTS_MAP = {};
export function useContactsMap(vendorId) {
  var _contactsMapData$cont, _contactsMapData$samp;
  const {
    contacts,
    isLoading,
    error,
    refresh
  } = useContacts();
  const {
    getNow
  } = useIoContext();
  const sampleContactPlaceholder = useMemo(() => ContactModel.makeSample({
    createdAt: getNow(),
    vendorId
  }), [vendorId, contacts]);
  const {
    data: contactsMapData
  } = useQueryState({
    queryKey: [QueryKeys.ContactsMap, vendorId, contacts],
    queryFn: async () => {
      const contactsMap = {};
      let sampleContact = sampleContactPlaceholder;
      for (let i = 0; i < contacts.length; i++) {
        const contact = contacts[i];
        if (contact.isSample()) {
          sampleContact = contact;
        } else {
          contactsMap[contact.id()] = contact;
        }
      }
      return {
        contactsMap,
        sampleContact
      };
    },
    cacheTime: 1 * 60 * 1000
  });
  return {
    contactsMap: (_contactsMapData$cont = contactsMapData === null || contactsMapData === void 0 ? void 0 : contactsMapData.contactsMap) !== null && _contactsMapData$cont !== void 0 ? _contactsMapData$cont : EMPTY_CONTACTS_MAP,
    sampleContact: (_contactsMapData$samp = contactsMapData === null || contactsMapData === void 0 ? void 0 : contactsMapData.sampleContact) !== null && _contactsMapData$samp !== void 0 ? _contactsMapData$samp : sampleContactPlaceholder,
    isLoading,
    error,
    fetchContacts: refresh
  };
}